"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleTypeQuery = void 0;
const base_listing_query_class_1 = require("../common/base-listing-query.class");
class MultipleTypeQuery extends base_listing_query_class_1.BaseListingQuery {
    constructor(config, queryService) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
    }
    toPromise() {
        var _a;
        return this.queryService.getMultipleTypes(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/types';
        return super.resolveUrlInternal(action);
    }
    map(json) {
        return this.queryService.mappingService.listContentTypesResponse(json);
    }
    allResponseFactory(items, responses) {
        return {
            items: items,
            responses: responses
        };
    }
}
exports.MultipleTypeQuery = MultipleTypeQuery;
//# sourceMappingURL=multiple-type-query.class.js.map